import type { ManagerAssessmentSkillSelectorOptionValue } from '@/constants/review/ManagerAssessmentSkillSelectorOption';
import type { ReviewQuestion } from '@/types/review/ReviewQuestion';

import { ReviewQuestionStatus } from '@/constants/questionnaire/Question';
import { ManagerAssessmentSkillSelectorOption } from '@/constants/review/ManagerAssessmentSkillSelectorOption';

export const hasActiveQuestions = (questions: readonly ReviewQuestion[] | undefined): boolean =>
    (questions ?? []).some((question) => question.status === ReviewQuestionStatus.ACTIVE);

export const willSkillScopeProduceQuestions = (
    skillSelectorOption: ManagerAssessmentSkillSelectorOptionValue | null | undefined,
): boolean =>
    !!skillSelectorOption &&
    skillSelectorOption !== ManagerAssessmentSkillSelectorOption.DO_NOT_ASSESS_SKILLS;
